<template>
	<contentBox v-bind:noScrollFix="true">
		<contentTitle v-if="features && features.length > 0" v-bind:label="features.length+' FEATURES'" labelClass="text-white">
		</contentTitle>
		<contentBody v-if="features && features.length > 0" bg="rgba(55,71,79,0.6)">
			<div ref="view" id="feature-list" class="w-100 p-2">			
				<div v-for="(feature, index) in features" :key="feature.layer.id+'-'+feature.id">
					<featureRow v-bind:feature="feature"></featureRow>
				</div>
			</div>
		</contentBody>
		
	</contentBox>
</template>
<script>

import contentBox from '../content';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';
import featureRow from './feature-row';

export default {
	name:'featureList',
	components:{
		contentBox,
		contentBody,
		contentTitle,
		featureRow
	},
	props: {
	},
	destroyed:function(){
		this.$store.dispatch('MAP_FEATURE_HOVER_SET',[]);
		this.$store.dispatch('MAP_ACTIVE_POINT_CLEAR',{});
	},
	computed:{
		features:function(){
			// make sure features have unique ids
			return this.$store.getters.mapActivePointFeatures;
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		},
		mapPoint:function(){
			return this.$store.state.map.clickPoint;
		}
	},
	methods:{
		checkReady:function(){ //called to check if and resolve when all resources have been loaded
			if (!this.mapLoaded) return;
			this.ready();
		},
		ready:function(){
			//if (this.features) return;
			const point = {
				lng:Number(this.$route.params.lng),
				lat:Number(this.$route.params.lat)
			};

			this.$store.dispatch('MAP_ACTIVE_POINT_SET',{
				point
			});
		},
		updateTitleTag:function(){
			document.title = this.features.length+' features - Scoutred Maps';
		},
		routeClose:function(){
			this.$router.push({
				name:'home'
			});
		}
	},
	mounted:function(){
		// wait until map loads
		this.checkReady();
	},
	watch:{
		$route:function(newRoute,prevRoute){
			// check if click pt has changed
			if (newRoute.params.lng === prevRoute.params.lng && newRoute.params.lat === prevRoute.params.lat) return;
			this.checkReady();
		},
		mapLoaded:function(){
			this.checkReady();
		},
		features:function(){
			this.updateTitleTag();
		}
	}
};

</script>

<style>
#feature-list .card{cursor:pointer;background-color:rgba(255,255,255,0.9);}
#feature-list .highlight,#feature-list .card:hover{background-color:rgba(255,255,255,1);}
</style>


// WEBPACK FOOTER //
// src/components/feature/feature-list.vue